import axios from 'axios'
import { getXhrUrl } from 'client/common/url'
import { changeMode, isLoading, setData } from 'client/fragments/listerFragment/store/reducer'
import { sortChanged } from 'client/common/gtmEvents'
import { updateWindowUrl } from './filterActions'

export const onSortByChange = ({
  format,
  lang,
  categoryCode,
  collectionId,
  ids,
  viewSize,
  userId,
  ipAddress,
  dispatch
}) => {
  return sortBy => {
    dispatch(isLoading(true))

    const url = new URL(global.document.location.href)
    const { origin, searchParams } = url
    if (sortBy.length === 0) searchParams.delete('sortBy')
    else searchParams.set('sortBy', sortBy)

    sortChanged(sortBy)
    updateWindowUrl(url)

    return axios
      .get(
        getXhrUrl({
          origin,
          format,
          lang,
          userId,
          categoryCode,
          collectionId,
          ids,
          viewSize,
          searchParams
        }),
        {
          headers: { ip: ipAddress }
        }
      )
      .then(resp => {
        const { products, meta, sort } = resp.data
        dispatch(isLoading(false))
        dispatch(setData({ products, meta, sort }))
        return resp
      })
  }
}

export const onPageChange = ({
  format,
  lang,
  categoryCode,
  collectionId,
  ids,
  viewSize,
  userId,
  ipAddress,
  dispatch
}) => {
  return page => {
    dispatch(isLoading(true))
    const url = new URL(global.document.location.href)
    const { origin, searchParams } = url

    if (page === 1) searchParams.delete('currentPage')
    else searchParams.set('currentPage', page)

    updateWindowUrl(url)

    return axios
      .get(getXhrUrl({ origin, format, lang, userId, categoryCode, collectionId, ids, viewSize, searchParams }), {
        headers: { ip: ipAddress }
      })
      .then(resp => {
        const { products, meta, page: pageData } = resp.data
        dispatch(isLoading(false))
        dispatch(
          setData({
            products,
            meta,
            page: {
              ...pageData,
              page
            }
          })
        )
        return resp
      })
  }
}

export const onPageContentSwitch = dispatch => {
  return mode => {
    const url = new URL(global.document.location.href)
    const { searchParams } = url
    const isToProductsChange = mode === 'products'
    dispatch(changeMode({ mode }))

    if (isToProductsChange) {
      searchParams.delete('page-mode')
    } else searchParams.set('page-mode', mode)

    updateWindowUrl(url)
  }
}
